module.exports = __webpack_public_path__ + "static/media/bmw-smorawinski.1736a3cd.webp";